export default function PageHeader({ eyebrow, title, subtitle, actions, testId }) {
  return (
    <div className="mb-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3" data-testid={testId}>
      <div>
        {eyebrow && (
          <div className="text-[11px] uppercase tracking-widest text-muted-foreground mb-1">{eyebrow}</div>
        )}
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-foreground">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
